export function projectInstitutionalContextLabel(project) {
  const context = project?.presentation?.institutionalContext || project?.institutionalContext;
  return [context?.institutionName, context?.unitName, context?.courseName]
    .filter(Boolean)
    .join(" · ");
}

export function projectParticipationContextLabel(project) {
  const context = project?.presentation?.institutionalContext || project?.institutionalContext;
  const neutral = projectInstitutionalContextLabel(project);
  return context?.relationship === "participant_affiliation" && context.institutionName
    ? `For participants at ${context.institutionName}`
    : neutral;
}

export function projectFacilitationContextLabel(project) {
  const context = project?.presentation?.institutionalContext || project?.institutionalContext;
  const neutral = projectInstitutionalContextLabel(project);
  return context?.relationship === "participant_affiliation" && context.institutionName
    ? `Participants · ${context.institutionName}`
    : neutral;
}

export function authorizedExternalProjectLogo(project) {
  const visualIdentity = project?.presentation?.visualIdentity || project?.visualIdentity;
  return visualIdentity?.source === "authorized_external"
    ? visualIdentity.logo || null
    : null;
}
